import { useEffect } from 'react';
import { useKeycloakAuth } from '@ui/app/useKeycloakAuth';
import { initializeCsrf } from '@ui/utils/csrf';
import CenteredLoader from '../layout/CenteredLoader';

interface AuthWrapperProps {
    children: React.ReactNode;
}

export default function AuthWrapper({ children }: AuthWrapperProps) {
    const { initialized } = useKeycloakAuth();

    useEffect(() => {
        if (initialized) {
            initializeCsrf();
        }
    }, [initialized]);

    if (!initialized) {
        return <CenteredLoader className="min-h-screen" />;
    }

    return <>{children}</>;
}
